import React from "react";
import { Box, Flex } from "rebass/styled-components";

import { layout } from "../../../../constants/constants";
import useBackgroundStyle from "../../../hooks/background-style/useBackgroundStyle";
import { CallToActionContent, IconPack } from "../../../models/app-data-model";
import HighImpactCta from "../high-impact-cta/high-impact-cta";
import LowImpactCta from "../low-impact-cta/low-impact-cta";
import "./call-to-action.scss";

export type CallToActionProps = {
  content: CallToActionContent;
  impact: "low" | "high";
  iconPack: IconPack[];
  modularBlock?: boolean;
};

const CallToAction: React.FC<CallToActionProps> = ({ content, impact, iconPack, modularBlock }: CallToActionProps) => {
  const backgroundStyle = useBackgroundStyle(content.background_color);

  return (
    <Flex className={`call-to-action-container ${impact}`} width={1}>
      <Box className={`call-to-action-card ${!modularBlock && "tabbed-width"}`} marginX={"auto"} paddingX={layout.pagePaddingX} width={modularBlock ? layout.pageWidth : 1}>
        <div className="call-to-action-bg" style={backgroundStyle} />
        {impact === "low" && <LowImpactCta iconPack={iconPack} content={content} />}
        {impact === "high" && <HighImpactCta iconPack={iconPack} content={content} />}
      </Box>
    </Flex>
  );
};

export default CallToAction;
